import { colors } from '../../../../../../../../../colorVars';
import { Body3 } from '../../../../../../../../../components/atomic/text/Text';
import ApplyRounding from '../../../../../../../../../utils/math/ApplyRounding';

const targetReasonMap = {
  ALREADY_IN_USE: 'because it is already in use.',
  DOES_NOT_EXIST: 'because it does not exist.',
  AUTOMATIC_EXIT: 'because it would result in an automatic exit.',
};

const adjustmentMap = {
  ADD: 'add',
  REMOVE: 'remove',
  EDIT: 'edit',
};

export function cannotUpdateTargetBuilder({parsedStatusObj}) {
  const { adjustmentType } = parsedStatusObj;
  return (
    <td>
      <Body3 fontWeight={500} color={colors.lightGrey}>
        Cannot {adjustmentType ? adjustmentMap[adjustmentType] : 'update'}
        {parsedStatusObj.price
          ? '$' + ApplyRounding(Number(parsedStatusObj.price), 2)
          : ''}{' '}
        target
        {parsedStatusObj.cannotAdjustReason
          ? targetReasonMap[parsedStatusObj.cannotAdjustReason]
          : ', reason unknown.'}
      </Body3>
    </td>
  );
}
